import { Toaster as SonnerToaster, toast } from 'sonner';

export { toast };
export const Toaster = SonnerToaster;
